import { Button, Flex, Text } from '@approvalmax/ui/src/components';
import { useSelector } from 'modules/react-redux';
import { memo, useMemo } from 'react';

import { getActiveReportConfig } from '../../selectors/pageSelectors';
import { FiltersPreview } from '../FiltersPreview/FiltersPreview';
import { useReportSetupPopup, useReportTypeLineItem } from './ReportSettings.hooks';
import { messages } from './ReportSettings.messages';

export const ReportSettings = memo(() => {
    const reportConfig = useSelector(getActiveReportConfig);
    const { integrationTemplates } = useReportTypeLineItem(reportConfig);

    const { popupShow } = useReportSetupPopup();

    const reportType = useMemo(() => {
        const type = integrationTemplates.find((template) => template.lineItemCode === reportConfig?.reportCode)?.text;

        return type || messages.request;
    }, [integrationTemplates, reportConfig]);

    if (!reportConfig) {
        return null;
    }

    return (
        <Flex container direction='column' spacing='12' data-qa='report-settings'>
            <Flex size={24}>
                <Text font='label' color='midnight70'>
                    {reportConfig.filterPreviews.length
                        ? messages.title({ type: reportType })
                        : messages.titleNoFilters({ type: reportType })}
                </Text>
            </Flex>

            <Flex size={24} direction='row' spacing='24' wrap={false}>
                <Flex block grow={1}>
                    <FiltersPreview filters={reportConfig.filterPreviews} />
                </Flex>

                <Flex grow={0} shrink={0} alignItems='start'>
                    <Button size='small' color='blue80' onClick={popupShow}>
                        {messages.buttonReportSetup}
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
});

ReportSettings.displayName = 'ReportSettings';
